import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {CreateFlightRequestTypes} from "app/types/service-types/FlightTypes"
import {FlightService} from "app/services"
import {toggleQuickPanel} from "app/main/shared-components/quick-panel/store";
import {fetchAllFlights} from "./flights-list.slice";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {getApiErrorMessage} from "app/utils/getApiErrorMessage";

interface CreateFlightStateParams {
  body: CreateFlightRequestTypes;
  onSuccess?: Function;
  onError?: Function;
}

export const createFlight = (params: CreateFlightStateParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));

    // Clean up the body: remove aircraftDefinitionId if present, keep only aircraftId
    const {aircraftDefinitionId, ...cleanBody} = params.body as any;
    
    const formatedBodyStructure = {
      ...cleanBody,
      // If aircraftDefinitionId was set but aircraftId is empty, use it
      aircraftId: cleanBody.aircraftId || aircraftDefinitionId || "",
    };

    const response = await FlightService.createFlight(formatedBodyStructure);
    if (response.status >= 200 && response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(toggleQuickPanel());
      dispatch(successMsg(localStorage.getItem("i18nextLng") === "en" ? "Flight added successfully!" : "Fluturimi u shtua me sukses!"));
      if (params.onSuccess) params.onSuccess();
      dispatch(setError(""));
      // @ts-ignore
      dispatch(fetchAllFlights());
    }
  } catch (err: unknown) {
    const message = getApiErrorMessage(err, "Something went wrong.");

    const isCriteriaMismatch = message.includes(
      "Criteria mismatched in total number of seats between flights and price sectors"
    );

    const finalMessage = isCriteriaMismatch
      ? "Criteria mismatched in total number of seats between flights and price sectors"
      : message;

    dispatch(errorMsg(finalMessage));
    if (params.onError) params.onError();
    dispatch(setError(finalMessage));
  } finally {
    dispatch(setLoading(false));
  }
};

interface CreateFlightSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: CreateFlightSlice = {
  error: '',
  success: false,
  loading: false
}

const stateSlice = createSlice({
  name: 'flights/create-flight',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setSuccess: (state, action) => {
      state.success = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;
